import qs from 'qs';
import { api } from '@/services/api/main/axios';
import { useReportParams } from '@/composables/useReportParams';

export const getSupportedDimensionsApiRequest = async (): Promise<Record<string, unknown>> => {
  const res = await api.get<{ payload: Record<string, unknown> }>('report/supported-dimensions');
  return res.data.payload;
};

export const getSupportedMetricsApiRequest = async (): Promise<unknown[]> => {
  const res = await api.get<{ payload: unknown[] }>('report/supported-metrics');
  return res.data.payload;
};

export type AggregatedReportChartPayload = {
  data: Record<string, unknown>;
  compareData?: Record<string, unknown>;
};

export const getAggregatedReportApiRequest = async (
  period: string,
  params: Record<string, unknown>,
): Promise<AggregatedReportChartPayload> => {
  const res = await api.get<{ payload: AggregatedReportChartPayload }>(
    `report/aggregated/${period}`,
    {
      params: {
        ...params,
        presetId: useReportParams().activePreset.value,
      },
      paramsSerializer: (serializedParams) =>
        qs.stringify(serializedParams, { arrayFormat: 'repeat' }),
    },
  );
  return res.data.payload;
};

export type ReportPayload = {
  data: unknown[];
  total?: Record<string, number>;
  count?: number;
};

export const getReportApiRequest = async (
  params: Record<string, unknown>,
): Promise<ReportPayload> => {
  const res = await api.get<{ payload: ReportPayload }>('report', {
    params: {
      ...params,
      presetId: useReportParams().activePreset.value,
    },
    paramsSerializer: (serializedParams) =>
      qs.stringify(serializedParams, { arrayFormat: 'repeat' }),
  });
  return res.data.payload;
};

export const getReportAtPathApiRequest = async (
  path: string,
  params: Record<string, unknown>,
  options: { presetId?: string } = {},
): Promise<ReportPayload> => {
  const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
  const res = await api.get<{ payload: ReportPayload }>(normalizedPath, {
    params: {
      ...params,
      presetId: options.presetId ?? useReportParams().activePreset.value,
    },
    paramsSerializer: (serializedParams) =>
      qs.stringify(serializedParams, { arrayFormat: 'repeat' }),
  });
  return res.data.payload;
};
